export default __webpack_public_path__ + "static/heart5-664e767a493bb75893a3793cbe251045.webp";